import { useState } from 'react'
import { Alert, Button, Dialog, Text, Textarea } from '~/shared/ui'

export function OnshoreOnlyDialog({
  isSettingOnshore,
  isOffshoreUser,
  isPending,
  error,
  onClose,
  onConfirm,
}: {
  isSettingOnshore: boolean
  isOffshoreUser: boolean
  isPending: boolean
  error: string | null
  onClose: () => void
  onConfirm: (notes: string) => void
}) {
  const [notes, setNotes] = useState('')

  return (
    <Dialog
      size="sm"
      onClose={onClose}
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            raised
            onClick={() => onConfirm(notes)}
            disabled={isPending}
          >
            {isPending ? 'Updating...' : 'Confirm'}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <Text
          className="text-text-primary"
          appearance="SUBTITLE2"
        >
          {isSettingOnshore ? 'Restrict to US reviewers?' : 'Remove US restriction?'}
        </Text>
        <Text
          className="text-text-secondary"
          appearance="CAPTION"
        >
          {isSettingOnshore
            ? isOffshoreUser
              ? 'This document and its consignment will be restricted to US-based reviewers only. Other documents in the consignment keep their visibility. You will no longer be able to see this document, and this change cannot be undone from your account.'
              : 'This document and its consignment will be restricted to US-based reviewers only. Other documents in the consignment keep their visibility.'
            : 'This document will become visible to all reviewers. The consignment stays restricted while another document in it is US-only.'}
        </Text>
        <Textarea
          filled
          placeholder="Provide justification for this change (optional)..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        {error && (
          <Alert
            appearance="ERROR"
            filled
          >
            {error}
          </Alert>
        )}
      </div>
    </Dialog>
  )
}
